import React, { useEffect, useState } from "react";
import { usePostHog } from "posthog-js/react";
import { useParams } from "react-router-dom";
import FarmLogo from "assets/Farm-Logo.png";

export function Survey() {
  const posthog = usePostHog();
  const { id } = useParams();
  const coolSurveyID = id;
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!coolSurveyID) return;
    setTimeout(() => {
      posthog.renderSurvey(coolSurveyID, "#survey-container");
      setLoading(false);
    }, 500);
  }, [coolSurveyID]);

  return (
    <div className="min-h-screen bg-[#F7FAF7] flex flex-col items-center py-10 px-4">
      <div className="flex flex-col items-center mb-8">
        <img src={FarmLogo} alt="Farm" className="w-20 mb-4" />
        <h1 className="text-3xl font-bold text-[#1F3F2B]">Customer Survey</h1>
      </div>
      <div id="survey-container" className="w-full max-w-2xl"></div>
    </div>
  );
}
